import React, { useState, useEffect, useRef } from 'react';

// Custom icons (replacing lucide-react)
const FolderIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-5l-2-2H5a2 2 0 00-2 2z" />
  </svg>
);

const PlusIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
  </svg>
);

const ActivityIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>
);

const KeyIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
  </svg>
);

const BarChartIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  </svg>
);

const ClockIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const UsersIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
  </svg>
);

const ZapIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>
);

const TargetIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
  </svg>
);

const FileCheckIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const SearchIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
);

const BLOCK_TYPES = [
  {
    id: 'projects',
    name: 'Projects',
    description: 'View and manage your projects',
    icon: FolderIcon,
    category: 'Core',
    keywords: ['project', 'folder', 'workspace'],
    color: 'bg-celadon-100 text-celadon-700'
  },
  {
    id: 'create-project',
    name: 'Create Project',
    description: 'Quick project creation form',
    icon: PlusIcon,
    category: 'Actions',
    keywords: ['new', 'create', 'add', 'project'],
    color: 'bg-gray-100 text-gray-700'
  },
  {
    id: 'composer-flows',
    name: 'Composer Flows',
    description: 'Visual prompt engineering flows by project',
    icon: ZapIcon,
    category: 'Core',
    keywords: ['composer', 'flows', 'visual', 'prompt', 'engineering', 'chains'],
    color: 'bg-celadon-100 text-celadon-700'
  },
  {
    id: 'test-sets',
    name: 'Test Sets',
    description: 'View and manage test sets by project',
    icon: FileCheckIcon,
    category: 'Testing',
    keywords: ['test', 'sets', 'testing', 'evaluation', 'cases'],
    color: 'bg-gray-100 text-gray-700'
  },
  {
    id: 'recent-activity',
    name: 'Recent Activity',
    description: 'Latest changes and updates',
    icon: ActivityIcon,
    category: 'Overview',
    keywords: ['recent', 'activity', 'updates', 'changes'],
    color: 'bg-gray-100 text-gray-700'
  },
  {
    id: 'api-keys',
    name: 'API Keys',
    description: 'Manage your API keys',
    icon: KeyIcon,
    category: 'Settings',
    keywords: ['api', 'keys', 'tokens', 'auth'],
    color: 'bg-gray-100 text-gray-700'
  },
  {
    id: 'analytics',
    name: 'Analytics',
    description: 'Usage statistics and insights',
    icon: BarChartIcon,
    category: 'Analytics',
    keywords: ['analytics', 'stats', 'metrics', 'insights'],
    color: 'bg-celadon-100 text-celadon-700'
  },
  {
    id: 'prompt-logs',
    name: 'Prompt Logs',
    description: 'Recent prompt executions',
    icon: ClockIcon,
    category: 'Monitoring',
    keywords: ['logs', 'history', 'executions', 'monitoring'],
    color: 'bg-gray-100 text-gray-700'
  },
  {
    id: 'shared-prompts',
    name: 'Shared Prompts',
    description: 'Prompts shared with you',
    icon: UsersIcon,
    category: 'Community',
    keywords: ['shared', 'community', 'public', 'prompts'],
    color: 'bg-gray-100 text-gray-700'
  },
  {
    id: 'experiments',
    name: 'Experiments',
    description: 'Recent experiments and A/B tests',
    icon: ZapIcon,
    category: 'Testing',
    keywords: ['experiments', 'ab test', 'testing', 'trials'],
    color: 'bg-celadon-100 text-celadon-700'
  },
  {
    id: 'quick-actions',
    name: 'Quick Actions',
    description: 'Shortcuts to common tasks',
    icon: TargetIcon,
    category: 'Actions',
    keywords: ['quick', 'shortcuts', 'actions', 'tasks'],
    color: 'bg-celadon-100 text-celadon-700'
  }
];

const CommandMenu = ({ isOpen, onClose, onSelectBlock, position }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const menuRef = useRef(null);
  const inputRef = useRef(null);

  const filteredBlocks = BLOCK_TYPES.filter(block => {
    const searchLower = searchTerm.toLowerCase();
    return (
      block.name.toLowerCase().includes(searchLower) ||
      block.description.toLowerCase().includes(searchLower) ||
      block.keywords.some(keyword => keyword.includes(searchLower))
    );
  });

  useEffect(() => {
    if (isOpen && inputRef.current) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [isOpen]);

  useEffect(() => {
    setSelectedIndex(0);
  }, [searchTerm]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          setSelectedIndex(prev => 
            prev < filteredBlocks.length - 1 ? prev + 1 : 0
          );
          break;
        case 'ArrowUp':
          e.preventDefault();
          setSelectedIndex(prev => 
            prev > 0 ? prev - 1 : filteredBlocks.length - 1
          );
          break;
        case 'Enter':
          e.preventDefault();
          if (filteredBlocks[selectedIndex]) {
            handleSelectBlock(filteredBlocks[selectedIndex]);
          }
          break;
        case 'Escape':
          e.preventDefault();
          onClose();
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, selectedIndex, filteredBlocks]);

  const handleSelectBlock = (block) => {
    onSelectBlock(block);
    setSearchTerm('');
    onClose();
  };

  const groupedBlocks = filteredBlocks.reduce((groups, block) => {
    const category = block.category;
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(block);
    return groups;
  }, {});

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div
        ref={menuRef}
        className="bg-white dark:bg-gray-800 rounded-2xl shadow-strong border border-gray-100 dark:border-gray-700 w-full max-w-lg mx-4 animate-scale-in"
        style={{
          maxHeight: '80vh',
          transform: position ? `translate(${position.x}px, ${position.y}px)` : undefined
        }}
      >
        {/* Header */}
        <div className="p-6 border-b border-gray-100 dark:border-gray-700">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-10 h-10 bg-gradient-celadon rounded-xl flex items-center justify-center">
              <SearchIcon />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Add Block</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">Search and add blocks to your dashboard</p>
            </div>
          </div>

          {/* Search input */}
          <div className="relative">
            <input
              ref={inputRef}
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Type to search blocks..."
              className="input"
            />
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
              <SearchIcon />
            </div>
          </div>
        </div>

        {/* Block list */}
        <div className="max-h-96 overflow-y-auto custom-scrollbar">
          {filteredBlocks.length === 0 ? (
            <div className="p-8 text-center">
              <div className="w-16 h-16 bg-gray-100 dark:bg-gray-700 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <SearchIcon />
              </div>
              <h4 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">No blocks found</h4>
              <p className="text-gray-500 dark:text-gray-400">Try searching with different keywords</p>
            </div>
          ) : (
            <div className="p-4">
              {Object.entries(groupedBlocks).map(([category, blocks]) => (
                <div key={category} className="mb-6 last:mb-0">
                  <h4 className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3 px-2">
                    {category}
                  </h4>
                  <div className="space-y-1">
                    {blocks.map((block, blockIndex) => {
                      const globalIndex = filteredBlocks.indexOf(block);
                      const IconComponent = block.icon;
                      const isSelected = globalIndex === selectedIndex;
                      
                      return (
                        <button
                          key={block.id}
                          onClick={() => handleSelectBlock(block)}
                          className={`
                            w-full text-left p-4 rounded-xl transition-all duration-200 group
                            ${isSelected 
                              ? 'bg-celadon-50 dark:bg-celadon-900/20 border border-celadon-200 dark:border-celadon-700 shadow-soft' 
                              : 'hover:bg-gray-50 dark:hover:bg-gray-700 border border-transparent'
                            }
                          `}
                        >
                          <div className="flex items-center space-x-4">
                            <div className={`
                              w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-200
                              ${isSelected ? block.color : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 group-hover:bg-gray-200 dark:group-hover:bg-gray-600'}
                            `}>
                              <IconComponent />
                            </div>
                            
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center justify-between">
                                <h5 className={`
                                  font-medium transition-colors duration-200
                                  ${isSelected ? 'text-gray-900 dark:text-gray-100' : 'text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-gray-100'}
                                `}>
                                  {block.name}
                                </h5>
                                {isSelected && (
                                  <kbd className="px-2 py-1 bg-white border border-celadon-200 rounded text-xs font-mono text-celadon-600">
                                    ↵
                                  </kbd>
                                )}
                              </div>
                              <p className={`
                                text-sm mt-1 transition-colors duration-200
                                ${isSelected ? 'text-gray-600 dark:text-gray-400' : 'text-gray-500 dark:text-gray-400'}
                              `}>
                                {block.description}
                              </p>
                            </div>
                          </div>
                        </button>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 rounded-b-2xl">
          <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-1">
                <kbd className="px-1.5 py-0.5 bg-white border rounded font-mono">↑↓</kbd>
                <span>navigate</span>
              </div>
              <div className="flex items-center space-x-1">
                <kbd className="px-1.5 py-0.5 bg-white border rounded font-mono">↵</kbd>
                <span>select</span>
              </div>
              <div className="flex items-center space-x-1">
                <kbd className="px-1.5 py-0.5 bg-white border rounded font-mono">esc</kbd>
                <span>close</span>
              </div>
            </div>
            <span>{filteredBlocks.length} blocks</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommandMenu; 